var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-gridview',{attrs:{"parentData":{
    pageTitle: this.pageTitle,
    tabHeaders: this.dataHeader,
    tabItems: this.dataItems,
    search: this.search,
    isAdvanceEdit: true,
    isDelete: true,
  }},on:{"AdvanceEditItem":function($event){return _vm.advanceEditItemHandler($event)},"EditItem":function($event){return _vm.editItemHandler($event)},"DeleteItem":function($event){return _vm.deleteItemHandler($event)},"NewPressed":_vm.newRecordHandler}}),(_vm.isConfirm)?_c('div',[_c('app-confirm',{attrs:{"parentObject":{
        messageConfirm: this.messageConfirm,
        isConfirm: this.isConfirm,
        }},on:{"confirm":_vm.deleteItemHandlerAction,"cancelConfirm":function($event){_vm.isConfirm = !_vm.isConfirm}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }